
import { format } from 'date-fns';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle
} from "@shadcn/components/ui/card";
import { Button } from "@shadcn/components/ui/button";
import { Download } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "@shadcn/components/ui/table";

const StateAnalysisSection = ({ stateData, dateRange, loading, exportStateData, exportLoading }) => {
  if (loading || !stateData || stateData.length === 0) {
    return null;
  }

  return (
    <Card className="mb-6 overflow-hidden">
      <CardHeader className="pb-4">
        <div className="flex justify-between items-center">
          <div>
            <CardTitle className="text-xl text-slate-800">Top & Bottom Sales by State</CardTitle>
            <p className="text-sm text-gray-600">
              Analysis based on selected date range: {format(dateRange.startDate, "dd/MM/yyyy")} to {format(dateRange.endDate, "dd/MM/yyyy")}
            </p>
          </div>
          <Button 
            variant="outline" 
            onClick={exportStateData}
            disabled={exportLoading}
            className="flex items-center gap-2"
          >
            <Download className="h-4 w-4" />
            {exportLoading ? 'Exporting...' : 'Export to Excel'}
          </Button>
        </div>
      </CardHeader>
      <CardContent className="space-y-8">
        {stateData.map((stateInfo, index) => (
          <div key={stateInfo._id || index} className="border-b border-gray-200 last:border-b-0 pb-8 last:pb-0">
            <h3 className="text-lg font-semibold mb-4 text-slate-700">{stateInfo.state}</h3>
            
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
              {/* Top Products */}
              <div>
                <h4 className="text-md font-medium mb-3 text-green-700">Top 10 Products</h4>
                <div className="overflow-x-auto overflow-y-auto border rounded-lg shadow-sm">
                  <Table className="w-full border">
                    <TableHeader className="bg-green-50 sticky top-0 z-10">
                      <TableRow>
                        <TableHead className="sticky top-0 bg-green-50 border-b border-gray-200">SKU</TableHead>
                        <TableHead className="sticky top-0 bg-green-50 border-b border-gray-200">Product</TableHead>
                        <TableHead className="sticky top-0 bg-green-50 border-b border-gray-200">Color</TableHead>
                        <TableHead className="text-center sticky top-0 bg-green-50 border-b border-gray-200">Total Qty</TableHead>
                        
                        <TableHead className="text-center sticky top-0 bg-green-50 border-b border-gray-200">Retail</TableHead>
                        <TableHead className="text-center sticky top-0 bg-green-50 border-b border-gray-200">Online</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {stateInfo.topProducts?.map((product, idx) => (
                                                  <TableRow key={`top-${stateInfo._id}-${idx}`} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                            <TableCell className="font-medium text-sm">{product.sku}</TableCell>
                            <TableCell className="text-sm w-[300px]">{product.productName}</TableCell>
                            <TableCell className="text-sm">{product.color}</TableCell>
                          <TableCell className="text-center font-semibold text-green-600">{product.totalQuantity}</TableCell>
                          
                          <TableCell className="text-center">{product.totalRetail}</TableCell>
                          <TableCell className="text-center">{product.totalOnline}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </div>

              {/* Bottom Products */}
              <div>
                <h4 className="text-md font-medium mb-3 text-red-700">Bottom 10 Products</h4>
                <div className="overflow-x-auto overflow-y-auto border rounded-lg shadow-sm">
                  <Table className="w-full border">
                    <TableHeader className="bg-red-50 sticky top-0 z-10">
                      <TableRow>
                        <TableHead className="sticky top-0 bg-red-50 border-b border-gray-200">SKU</TableHead>
                        <TableHead className="sticky top-0 bg-red-50 border-b border-gray-200">Product</TableHead>
                        <TableHead className="sticky top-0 bg-red-50 border-b border-gray-200">Color</TableHead>
                        <TableHead className="text-center sticky top-0 bg-red-50 border-b border-gray-200">Total Qty</TableHead>
                        
                        <TableHead className="text-center sticky top-0 bg-red-50 border-b border-gray-200">Retail</TableHead>
                        <TableHead className="text-center sticky top-0 bg-red-50 border-b border-gray-200">Online</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {stateInfo.bottomProducts?.map((product, idx) => (
                                                  <TableRow key={`bottom-${stateInfo._id}-${idx}`} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                            <TableCell className="font-medium text-sm">{product.sku}</TableCell>
                            <TableCell className="text-sm w-[300px]">{product.productName}</TableCell>
                            <TableCell className="text-sm">{product.color}</TableCell>
                          <TableCell className="text-center font-semibold text-red-600">{product.totalQuantity}</TableCell>
                          
                          <TableCell className="text-center">{product.totalRetail}</TableCell>
                          <TableCell className="text-center">{product.totalOnline}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default StateAnalysisSection; 
